import type { SVGAttributes } from 'react';
import type { ChakraProps } from '@chakra-ui/react';
import { chakra } from '@chakra-ui/react';

type Props = Omit<SVGAttributes<SVGElement>, keyof ChakraProps> & ChakraProps;

const Svg = chakra('svg');
const Circle = chakra('circle');

const DropZoneIllustration = ({ color, ...rest }: Props) => {
  return (
    <Svg width={128} height={128} viewBox='0 0 128 128' fill='none' {...rest}>
      <Circle cx='64' cy='64' r='64' fill={color} />
      <path
        d='M64 78V50'
        stroke='white'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M50 64L64 50L78 64'
        stroke='white'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </Svg>
  );
};

export default DropZoneIllustration;
